import { useStyles } from './styles';
import { type ReactNode } from 'react';

type WithIconProps = {
  icon?: ReactNode;
  label?: string | null;
};

const WithIcon = ({ icon, label }: WithIconProps) => {
  const classes = useStyles();

  if (!icon || !label) {
    return <>-</>;
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.label}>{label}</div>
      <>{icon}</>
    </div>
  );
};

export default WithIcon;
